import React, { useEffect, useState } from "react";
import Service from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";

import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

const TemplateMaster = () => {
  const [templates, setTemplates] = useState([]);
  const [holidayList, setHolidayList] = useState([]);

  const [form, setForm] = useState({
    templateId: 0,
    title: "",
    message: "",
    templateType: "",
    file: null, //  ADD THIS
    imagePath: "", //  ADD THIS
    opFlag: "INSERT",
    createdBy: sessionStorage.getItem("userEmail") || "admin",
  });

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [fileKey, setFileKey] = useState(Date.now());

  // ================= LOAD DATA =================

  const loadTemplates = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Template");
      const res = await Service.getAll();
      setTemplates(res.data);
    } catch (err) {
      console.error("Template load error:", err);
    }
  };

  // const loadHolidays = async () => {
  //   try {
  //     Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Holiday");
  //     const res = await Service.getAll();
  //     setHolidayList(res.data);
  //   } catch (err) {
  //     console.error("Holiday load error:", err);
  //   }
  // };

  const loadHolidays = async () => {
  try {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Holiday");

    const res = await Service.getAll();

    // Remove empty names and trim spaces
    const validHolidays = res.data
      .filter((h) => h.holidayName?.trim())
      .map((h) => ({
        ...h,
        holidayName: h.holidayName.trim(),
      }));

    // Remove duplicates and keep the LAST record
    const uniqueHolidays = validHolidays.filter(
      (holiday, index, self) =>
        index ===
        self
          .map((h) => h.holidayName.toLowerCase())
          .lastIndexOf(holiday.holidayName.toLowerCase())
    );

    setHolidayList(uniqueHolidays);
  } catch (err) {
    console.error("Holiday load error:", err);
  }
};

  useEffect(() => {
    loadTemplates();
    loadHolidays();
  }, []);

  // ================= SAVE =================

  // const save = async () => {
  //   try {
  //     const formData = new FormData();

  //     formData.append("TemplateId", form.templateId);
  //     formData.append("Title", form.title);
  //     formData.append("Message", form.message);
  //     formData.append("TemplateType", form.templateType);
  //     formData.append("OpFlag", form.opFlag);
  //     formData.append("CreatedBy", form.createdBy);

  //     if (form.file) {
  //       formData.append("file", form.file);
  //     } else {
  //       formData.append("file", new Blob([])); // 🔥 FIX
  //     }

  //     Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Template");

  //     const res = await Service.create(formData); // ✅ NO headers

  //     setSnackbar({
  //       open: true,
  //       message: res.data.message,
  //       severity: "success",
  //     });

  //     await loadTemplates();
  //     reset();
  //   } catch (err) {
  //     console.error("Save error:", err);
  //   }
  // };

  const save = async () => {
    try {
      // ================= TRIM VALUES =================
      const title = form.title.trim();
      const message = form.message.trim();
      const templateType = form.templateType.trim();

      // ================= TITLE VALIDATION =================

      // Empty / whitespace-only Title
      if (!title) {
        setSnackbar({
          open: true,
          message: "Title is required",
          severity: "error",
        });
        return;
      }

      // Title must contain at least one letter or number
      // Rejects: @#$%, !!!, ###, etc.
      if (!/[\p{L}\p{N}]/u.test(title)) {
        setSnackbar({
          open: true,
          message: "Title must contain at least one letter or number",
          severity: "error",
        });
        return;
      }

      // Template Type validation
      if (!templateType) {
        setSnackbar({
          open: true,
          message: "Template Type is required",
          severity: "error",
        });
        return;
      }

      // ================= MESSAGE VALIDATION =================

      // Empty / whitespace-only Message
      if (!message) {
        setSnackbar({
          open: true,
          message: "Message is required",
          severity: "error",
        });
        return;
      }

      // Message must contain at least one letter or number
      if (!/[\p{L}\p{N}]/u.test(message)) {
        setSnackbar({
          open: true,
          message: "Message must contain valid text",
          severity: "error",
        });
        return;
      }

      // Reject a single-character message such as "d"
      if (message.length < 5) {
        setSnackbar({
          open: true,
          message: "Message must contain at least 5 characters",
          severity: "error",
        });
        return;
      }

      // ================= FILE VALIDATION =================

      if (form.file) {
        const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];

        if (!allowedTypes.includes(form.file.type)) {
          setSnackbar({
            open: true,
            message: "Only JPG, JPEG, PNG and SVG files are allowed",
            severity: "error",
          });
          return;
        }
      }

      //  Duplicate Check
      const alreadyExists = templates.some(
        (x) =>
          x.templateType === form.templateType &&
          x.templateId !== form.templateId,
      );

      if (alreadyExists) {
        setSnackbar({
          open: true,
          message: "Template already exists for this type",
          severity: "error",
        });

        return;
      }
      const formData = new FormData();

      formData.append("TemplateId", form.templateId);
      formData.append("Title", title);
      formData.append("Message", message);
      formData.append("TemplateType", templateType);
      formData.append("OpFlag", form.opFlag);
      formData.append("CreatedBy", form.createdBy);

      if (form.file) {
        formData.append("file", form.file);
      } else {
        formData.append("file", new Blob([]));
      }

      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Template");

      const res = await Service.create(formData);

      // ✅ SUCCESS
      setSnackbar({
        open: true,
        message: res.data.message,
        severity: "success",
      });

      await loadTemplates();
      reset();
    } catch (err) {
      console.error("Save error:", err);

      let errorMsg = "Something went wrong";

      if (err.response) {
        // ✅ if API returns {message:"..."}
        if (err.response.data?.message) {
          errorMsg = err.response.data.message;
        }

        // ✅ if API returns plain string
        else if (typeof err.response.data === "string") {
          errorMsg = err.response.data;
        }
      }

      setSnackbar({
        open: true,
        message: errorMsg,
        severity: "error",
      });
    }
  };

  // ================= EDIT =================

  const edit = (row) => {
    setForm({
      templateId: row.templateId,
      title: row.title?.trim() || "",
      message: row.message?.trim() || "",
      templateType: row.templateType?.trim() || "",
      imagePath: row.imagePath || "",
      file: null, //  ADD THIS
      opFlag: "UPDATE",
      createdBy: sessionStorage.getItem("userEmail") || "admin",
    });
  };

  // ================= DELETE =================

  const remove = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Template");

      const res = await Service.remove(deleteId, "DELETE");

      setSnackbar({
        open: true,
        message: res.data.message,
        severity: "success",
      });

      await loadTemplates();
      setConfirmOpen(false);
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // ================= RESET =================

  const reset = () => {
    setForm({
      templateId: 0,
      title: "",
      message: "",
      templateType: "",
      file: null,
      imagePath: "",

      opFlag: "INSERT",
      createdBy: sessionStorage.getItem("userEmail") || "admin",
    });
    setFileKey(Date.now()); //  force reset input
  };

  // ================= TABLE =================

  const columns = [
    { field: "title", headerName: "Title", flex: 1 },
    { field: "templateType", headerName: "Type", flex: 1 },
    { field: "message", headerName: "Message", flex: 1 },
    {
      field: "imagePath",
      headerName: "Image",
      width: 120,

      renderCell: (params) =>
        params.row.imagePath ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              paddingTop: "16px",
              paddingBottom: "16px",
            }}
          >
            <img
              src={`https://vmsapi.iecsl.in${params.row.imagePath}`}
              // src={`http://localhost:5211${params.row.imagePath}`}


              alt="template"
              width="60"
              height="60"
              style={{
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />
          </div>
        ) : (
          "No Image"
        ),
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            height: "100%",
            gap: "8px",
            paddingRight: "16px", //  extra space on right
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => edit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => remove(params.row.templateId)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  // ================= UI =================

  return (
    <div className="container mt-4">
      <h3>Template Master</h3>

      {/* TITLE */}
      <label className="form-label">
        Title <span style={{ color: "red" }}>*</span>
      </label>
      <input
        className="form-control mb-2"
        placeholder="Title  (e.g. Happy {{event}} {{name}})"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      {/* TEMPLATE TYPE */}
      <label className="form-label">
        Type <span style={{ color: "red" }}>*</span>
      </label>
      <select
        className="form-control mb-2"
        value={form.templateType}
        onChange={(e) => setForm({ ...form, templateType: e.target.value })}
      >
        <option value="">Select Type </option>

        {/* STATIC */}
        <option value="BIRTHDAY">Birthday</option>
        <option value="ANNIVERSARY">Anniversary</option>

        {/* DYNAMIC HOLIDAYS */}
        {holidayList.map((h) => (
          <option key={h.holidayID} value={h.holidayName}>
            {h.holidayName}
          </option>
        ))}
      </select>

      {/* MESSAGE */}
      <label className="form-label">
        Message <span style={{ color: "red" }}>*</span>
      </label>
      <textarea
        className="form-control mb-2"
        placeholder="Message"
        value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })}
      />

      {/* IMAGE UPLOAD */}
      <input
        key={fileKey}
        type="file"
        className="form-control mb-2"
        accept=".jpg,.jpeg,.png,.svg"
        onChange={(e) => setForm({ ...form, file: e.target.files[0] })}
      />

      {/* BUTTONS */}
      <button className="btn btn-primary me-2" onClick={save}>
        {form.opFlag === "INSERT" ? "Save" : "Update"}
      </button>

      <button className="btn btn-secondary" onClick={reset}>
        Reset
      </button>

      <hr />

      {/* TABLE */}
      <Box sx={{ width: "100%" }}>
        <DataGrid
          autoHeight
          rows={templates}
          columns={columns}
          getRowId={(row) => row.templateId}
          components={{ Toolbar: GridToolbar }}
          rowHeight={65}
        />
      </Box>

      {/* DELETE MODAL */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this template?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* SNACKBAR */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default TemplateMaster;
